var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"eno-search"},[_c('transition',{attrs:{"name":"el-fade-in"}},[_c('div',{staticClass:"eno-search-text"},[_c('i',{staticClass:"el-icon-search search-icon"}),_c('span',{staticClass:"search-text"},[_vm._v("搜索")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }